import { render, staticRenderFns } from "./CustomCommand.vue?vue&type=template&id=65b8956c&"
import script from "./CustomCommand.vue?vue&type=script&lang=js&"
export * from "./CustomCommand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports